
import Route from 'react-router/lib/Route';
import meQuery from './queries/MeQuery';
import React from 'react';

import Panel from './view/Panel.react.js';
import MinifiedPanel from './view/MinifiedPanel.react';
import Menu from './view/Menu.react.js';
import MenuChannel from './view/MenuChannel.react';
import EmptyPanel from './view/EmptyPanel.react';
import NoScreenPanel from './view/NoScreenPanel.react';
import LoadingScreenPanel from './view/LoadingScreenPanel.react';
import NoChannelPanel from './view/NoChannelPanel.react';
import InternalError from './view/InternalError.react';
import InternalErrorMinified from './view/InternalErrorMinified.react';
import WidgetConfig from './view/screen-settings/WidgetConfig.react';
import CreateScreenStep1 from './view/screen-settings/CreateScreenStep1.react.js';
import CreateScreenStep2 from './view/screen-settings/CreateScreenStep2.react.js';
import ListWithoutPanel from './view/screen-settings/ListWithoutPanel.react.js';
import NotLogged from './view/NotLogged.react';
import {RegularPanel, MiniPanel, FullScreenPanel} from './view/EmbededPanel.react';
import {LoadingLine} from './loadingLine/renderLoadingPanel.react';
import {lastPanelController} from './view/EmbededPanelController';
import RequiredCaching from './view/RequiredCaching.react';

function renderLoadingPanel(args) {
	if (args && args.error && args.error.fetchResponse && args.error.fetchResponse.status && 403 === args.error.fetchResponse.status) {
		return (<NotLogged />);
	}

	if (args && args.props) {
		return React.cloneElement(args.element, args.props);
	}

	if (lastPanelController()) {
		if (lastPanelController().hadRegular()) {
			return <RegularPanel isReloading typeForTest="reloading" />;
		}

		if (lastPanelController().hadFullScreen()) {
			return <FullScreenPanel isReloading typeForTest="reloading" />;
		}
	}

	if (args && args.routerProps && args.routerProps.route && args.routerProps.route.fullscreen) {
		return (
			<FullScreenPanel isReloading typeForTest="reloading">
				<LoadingLine />
			</FullScreenPanel>
		);
	}

	// in case the screen was recently created -> the window config isn't updated && expect regular panel
	if (lastPanelController() && lastPanelController().props.params.screenId) {
		return <RegularPanel isReloading typeForTest="reloading" />;
	}

	if (window['config'] && 'isInjected' in window['config'] && Boolean(window['config']['isInjected'])) {
		return <RegularPanel isReloading typeForTest="reloading" />;
	}

	return <MiniPanel isReloading typeForTest="reloading" />;
}

export default function createRoutes() {
	let defaultArgs = {
		queries: meQuery,
		render: renderLoadingPanel
	};

	return (
		<Route path="">
			<Route path="panel/">
				<Route name="organisations:list" path="organisations/">
					<Route name="organisations:view" path=":organisationId/">
						<Route component={Menu} name="Menu" path="menu/" {...defaultArgs} />
						<Route component={MenuChannel} name="Channel" path="menu/:channelId/" {...defaultArgs} />

						<Route name="Channels" path="channels/">
							<Route name="Channel" path=":channelId/">

								<Route name="screens:list" path="screens/">
									<Route name="screens:view" path=":screenId/">
										<Route component={Panel} name="Panel" path="panel/:data/" {...defaultArgs} />
										<Route component={MinifiedPanel} name="Mini Panel" path="mini/:data/" {...defaultArgs} />
										<Route component={() => import(/* webpackChunkName: "ScreenSettings" */ './view/screen-settings/ScreenSettings.react.js')} lazy name="Settings" path="screen-settings/" {...defaultArgs} />
										<Route component={WidgetConfig} fullscreen name="Panel Widget Configuration" path="widget-config/view/:viewId/:opener/" {...defaultArgs} />
									</Route>
								</Route>

								<Route name="Panel" path="panel/">
									<Route component={CreateScreenStep1} name="Create Screen" path="create-screen/:channelEntityDefId/step-1/" {...defaultArgs} />
									<Route component={CreateScreenStep2} name="Create Screen - step 2" path="create-screen/:channelEntityDefId/step-2/" {...defaultArgs} />
									<Route component={NoScreenPanel} name="No Screen" path="no-screen/" {...defaultArgs} />
									<Route component={LoadingScreenPanel} name="Loading Screen" path="loading/" render={renderLoadingPanel} />
									<Route component={RequiredCaching} name="Required Caching" path="required-caching/:cachingChannelId/" {...defaultArgs} />
								</Route>
							</Route>
						</Route>
					</Route>
				</Route>

				<Route component={ListWithoutPanel} name="List without Panel" path="list-without-panel/channels/:channelDefId/channel-mapping/:channelMappingDefId/" {...defaultArgs} />
				<Route component={NoChannelPanel} name="No Screen" path="no-channel/:channelDefId/" {...defaultArgs} />
				<Route component={EmptyPanel} name="No Screen" path="empty/" {...defaultArgs} />
				<Route component={NotLogged} name="Not Logged" path="not-logged/" render={renderLoadingPanel} />
				<Route component={InternalError} name="Internal error" path="error/" {...defaultArgs} />
				<Route component={InternalErrorMinified} name="Internal error" path="error-mini/" {...defaultArgs} />
			</Route>
		</Route>
	);

}
